import { useState } from "react";
import Select from "react-select";
import axios from "axios";

const AddHospitalForm = ({ hospital, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    hospitalName: hospital?.hospitalName || "",
    hospitalAddress: hospital?.hospitalAddress || "",
    hospitalCity: hospital?.hospitalCity,
    hospitalPinCode: hospital?.hospitalPinCode || "",
    countryCode: hospital?.countryCode || "",
    hospitalPhoneNumber: hospital?.hospitalPhoneNumber || "",
    hospitalEmail: hospital?.hospitalEmail || "",
    id: hospital?._id || "",
  });
  const [errors, setErrors] = useState({});

  const countryCodeOptions = [
    { value: "+1", label: "US (+1)" },
    { value: "+91", label: "India (+91)" },
    { value: "+44", label: "UK (+44)" },
    { value: "+61", label: "Australia (+61)" },
    { value: "+81", label: "Japan (+81)" },
  ];

  const validateField = (name, value) => {
    const fieldErrors = {};

    if (!value) {
      fieldErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required.`;
    } else if (
      name === "hospitalEmail" &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ) {
      fieldErrors[name] = "Please enter a valid email address.";
    } else if (name === "hospitalPhoneNumber" && !/^\d{10}$/.test(value)) {
      fieldErrors[name] = "Phone number must be 10 digits.";
    } else if (name === "profileImage" && value) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(value.type)) {
        fieldErrors[name] = "Only JPG and PNG images are allowed.";
      }
    }

    return fieldErrors;
  };

  const validateAll = () => {
    const newErrors = {};
    for (const [key, value] of Object.entries(formData)) {
      const fieldErrors = validateField(key, value);
      Object.assign(newErrors, fieldErrors);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Field Changed:", name, value);
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      validateField(name, value);
    }
  };
  const handleCountryCodeChange = (selectedOption) => {
    setFormData({ ...formData, countryCode: selectedOption?.value || "" });
    if (errors["countryCode"]) {
      validateField("countryCode", selectedOption?.value || "");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("File Selected:", file);
    if (file) {
      validateField("profileImage", file);
    }
    setFormData({ ...formData, profileImage: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Before Validation:", formData);

    if (true) {
      console.log("Validation Passed!");

      const formDataToSubmit = new FormData();

      // Append data to FormData
      Object.keys(formData).forEach((key) => {
        if (key === "profileImage" && formData.profileImage instanceof File) {
          formDataToSubmit.append("image", formData.profileImage);
        } else if (formData[key] !== undefined && formData[key] !== null) {
          formDataToSubmit.append(key, formData[key]);
        }
      });

      // Debugging FormData
      console.log("FormData Contents:");
      for (let [key, value] of formDataToSubmit.entries()) {
        console.log(key, value);
      }
      await onSubmit(formDataToSubmit);
    } else {
      console.log("Form Validation Failed:", errors);
    }
  };

  return (
    <div className="form-container">
      <p className="back-link" onClick={onCancel}>
        Back
      </p>
      <form className="registration-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Hospital Name</label>
          <input
            type="text"
            name="hospitalName"
            value={formData.hospitalName}
            onChange={handleChange}
            placeholder="Enter hospital name"
          />
          <small className="help-text">
            Enter the name of the Hospital. This will appear in all official
            communications and records.
          </small>
          {errors.hospitalName && (
            <p className="error-text">{errors.hospitalName}</p>
          )}
        </div>

        <div className="form-group">
          <label>Country Name</label>
          <input
            type="text"
            name="hospitalCity"
            value={formData.hospitalCity}
            onChange={handleChange}
            placeholder="Enter country name"
          />
          <small className="help-text">
            Enter the country name of the hospital. This is important for
            identification purposes.
          </small>
          {errors.hospitalCity && (
            <p className="error-text">{errors.hospitalCity}</p>
          )}
        </div>

        <div className="form-group">
          <label>Director Name</label>
          <input
            type="text"
            name="hospitalPinCode"
            value={formData.hospitalPinCode}
            onChange={handleChange}
            placeholder="Enter country name"
          />
          <small className="help-text">
            Enter the director name of the hospital. This is important for
            identification purposes.
          </small>
          {errors.hospitalPinCode && (
            <p className="error-text">{errors.hospitalPinCode}</p>
          )}
        </div>

        <div className="form-group">
          <label>Address</label>
          <textarea
            name="hospitalAddress"
            value={formData.hospitalAddress}
            onChange={handleChange}
            placeholder="Enter full address"
            rows="3"
          />
          <small className="help-text">
            Provide the complete address of the hospital, including street,
            city, state, and postal code. This information is necessary for
            official records and correspondence.
          </small>
          {errors.hospitalAddress && (
            <p className="error-text">{errors.hospitalAddress}</p>
          )}
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <Select
              options={countryCodeOptions}
              defaultValue={countryCodeOptions.find(
                (option) => option.value === formData?.countryCode
              )}
              onChange={handleCountryCodeChange}
              isClearable
              className="country-code-dropdown"
            />
            <input
              type="text"
              name="hospitalPhoneNumber"
              value={formData.hospitalPhoneNumber}
              onChange={handleChange}
              placeholder="Enter phone number"
              style={{ flex: 1 }}
            />
          </div>
          <small className="help-text">
            Enter a valid phone number where the staff member can be reached.
            Include the country code if applicable.
          </small>
          {errors.hospitalPhoneNumber && (
            <p className="error-text">{errors.hospitalPhoneNumber}</p>
          )}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="hospitalEmail"
            value={formData.hospitalEmail}
            onChange={handleChange}
            placeholder="Enter email"
          />
          <small className="help-text">
            Provide a valid email address for the staff member. This will be
            used for login and official communications.
          </small>
          {errors.hospitalEmail && (
            <p className="error-text">{errors.hospitalEmail}</p>
          )}
        </div>

        <div className="form-group">
          <label>Profile Image</label>
          <input type="file" name="profileImage" onChange={handleFileChange} />
          <small className="help-text">
            Upload a clear and recent profile image of the staff member. This
            helps in easy identification within the system.
          </small>
        </div>

        <button type="submit" className="submit-button">
          {hospital ? "Edit Hospital" : "Add Hospital"}
        </button>
      </form>
    </div>
  );
};

export default AddHospitalForm;
